export const NEKI_TWITTER_SITE_ID = '1296672399400804353';
export const NEKI_LOGO_S3_URL = 'https://s3.amazonaws.com/my.neki.io.prod/assets/images/Neki-Logo.svg';
export const DEFAULT_USER_BANNER_IMAGE = 'assets/images/default-profile-banner.png';